export const getListYears = () => {

    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = 2000; year < currentYear; year++) {
        years.push({
            label: year.toString(),
            value: year
        });
    };

    return years.reverse();

};